import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbAverageFromArrayOfValues,
    BBBreachRiskSubscriptionBadge, bbCreateArtificialEntityForPortfolioGroupsUsing,
    bbDangerousStringToDate, bbDictionaryOfBreachRiskLevels,
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity,
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFormattedDateString, bbGetDisplayNameFromAPIFidelity, bbIsObject, bbNumDaysBetweenDates, bbShortenString,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor,
    filterObject, isCurrentUserMemberOf,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip, BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {Badge, Col, Row} from "reactstrap";
import {Button, Chip} from "@material-ui/core";
import BRPortfolioAddNewEntityDialog from "./BRPortfolioAddNewEntityDialog";
import {deleteBRPortfolioEntity, fetchRiskPortfolio} from "../../../actions";
import BRPortfolioAddReportRequestDialog from "./BRPortfolioAddReportRequestDialog";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconArchive from "../../../assets/bbCustomIcons/BBIconArchive";
import BBIconLevelUpArrowEscalation from "../../../assets/bbCustomIcons/BBIconLevelUpArrowEscalation";
import BBIconVerifiedUserActiveAccount from "../../../assets/bbCustomIcons/BBIconVerifiedUserActiveAccount";
import BBIconWaitingHourglass from "../../../assets/bbCustomIcons/BBIconWaitingHourglass";
import BRFidelityBadge from "./BRFidelityBadge";
import {HashLink as Link} from "react-router-hash-link";
import BBIconAttestation from "../../../assets/bbCustomIcons/BBIconAttestation";
import BBIconTechData from "../../../assets/bbCustomIcons/BBIconTechData";
import BBIconGraphChart from "../../../assets/bbCustomIcons/BBIconGraphChart";
import {CircularProgress, Paper} from "@mui/material";
import BBIconEmptyBox from "../../../assets/bbCustomIcons/BBIconEmptyBox";
import BBExternalLink from "../accents/BBExternalLink";
import BBIconAddNetwork from "../../../assets/bbCustomIcons/BBIconAddNetwork";
import TileBreachRiskPortfolioNumEntitiesSimple from "../metrics/TileBreachRiskPortfolioNumEntitiesSimple";
import BRPortfolioAddNewSubportfolioDialog from "./BRPortfolioAddNewSubportfolioDialog";
import BRPortfolioAddEntityToSubportfolioDialog from "./BRPortfolioAddEntityToSubportfolioDialog";
import BRPortfolioRemoveEntityFromSubportfolioDialog from "./BRPortfolioRemoveEntityFromSubportfolioDialog";
import PortfolioEntityRisk2DScatterPlot from "../charts/PortfolioEntityRisk2DScatterPlot";
import Widget from "../../prefabricated/Widget";
import RiskComparisonFactBar from "../charts/RiskComparisonFactBar";
import EarlyAccessWrapper from "../settings/EarlyAccessWrapper";
import BRPortfolioArchiveEntityDialog from "./BRPortfolioArchiveEntityDialog";
import TileBreachRiskPortfolioInsightsRiskCategories from "../metrics/TileBreachRiskPortfolioInsightsRiskCategories";
import BRCompanyScoreVerifiedBadge from "../BBRiskMeter/BRCompanyScoreVerifiedBadge";
import BRCompanyScopeProgressBadge from "../BBRiskMeter/BRCompanyScopeProgressBadge";
import BBIconBreachRiskScore from "../../../assets/bbCustomIcons/BBIconBreachRiskScore";
import BreachRiskScoreIcon from "../accents/BreachRiskScoreIcon";
import BBIconCompanyVerifiedCheck from "../../../assets/bbCustomIcons/BBIconCompanyVerifiedCheck";
import BBIconAccountTrustedAgent from "../../../assets/bbCustomIcons/BBIconAccountTrustedAgent";
import BBIconVerified from "../../../assets/bbCustomIcons/BBIconVerified";
import UpdateEntityNameDialog from "./UpdateEntityNameDialog";

const TableContainer = ({
                            showInsightsDetails = false,
                            showManagementOptions = false,
                            showCustomerProcessSteps = false,
                            tableTitleText = "Portfolio Entities",
                            tableTipText = null,
                            tableDescription = null,
                            tableTitleIcon = null,
                            showOnlyEntitiesFromTheseSubportfolios = null, //use array when sending
                            primarySubportfolioInView = false,
                            hideTitleHeader = false,
                            showAnalyticsView = false,
                            showSlimView = false, //for when table is combined with graphs in a widget
                            showAnalyticsWidget = false, //dial and chart added to left and right
                            showMicroAnalyticsWidget = false, //the smallest of the analytics widgets, for group to group comparison
                            showRiskCategoriesPieInsteadOfTable = false

                        }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, loadingPortfolios, loadingPortfoliosError, selfEntityId, loadingDeleteBRPortfolioEntity,
        loadingDeleteBRPortfolioEntityError, loadingAddBRPortfolioReportRequest, loadingAddBRPortfolioReportRequestError, loadingAddBRPortfolioEntity, loadingAddBRPortfolioEntityError} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);
    const isAdminStaff = isCurrentUserMemberOf(authUser,"admin") || isCurrentUserMemberOf(authUser, "staff");

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    // console.log("myEntity data", myEntity);

    const dispatch = useDispatch();

    const hasEarlyAccess = EarlyAccessWrapper();

    const onlyShowEntitiesIncludedInSubportfolio = showOnlyEntitiesFromTheseSubportfolios && Array.isArray(showOnlyEntitiesFromTheseSubportfolios);

    const arrayOfEntityIdsToIncludeInSubportfolioFilter = [] ;
    //go through the subportfolios provided and extract all of the entityIds
    if(showOnlyEntitiesFromTheseSubportfolios && Array.isArray(showOnlyEntitiesFromTheseSubportfolios)){
        console.log("Looking through showOnlyEntitiesFromTheseSubportfolios to find entityIds", "showOnlyEntitiesFromTheseSubportfolios", showOnlyEntitiesFromTheseSubportfolios);
        for (const subportfolio of showOnlyEntitiesFromTheseSubportfolios) {
            if(subportfolio.entities && Array.isArray(subportfolio.entities)){
                //go through each entity and add the id to the array.
                for (const entity of subportfolio.entities) {

                    if(entity && entity.entity){
                        arrayOfEntityIdsToIncludeInSubportfolioFilter.push(entity.entity);
                    } else {
                        console.warn("Looking for entity Ids in subportfolios but entity does not have an id", "entity", entity);
                    }

                }
            } else {
                console.warn("Looking for entity Ids in subportfolios but subportfolio.entities did not pass checks to iterate", "subportfolio", subportfolio);
            }
        }
    }

    const entities = portfolios && portfolios[customerIdToUse]
        ? filterObject(portfolios[customerIdToUse].entities, (_, entity) => {
                            return entity.id !== selfEntityId
                        })
        : null;

    const entitiesInSubportfolios = entities
        ? filterObject(entities, (_, entity) => {
            return  showOnlyEntitiesFromTheseSubportfolios
                    && Array.isArray(showOnlyEntitiesFromTheseSubportfolios)
                    && showOnlyEntitiesFromTheseSubportfolios.length > 0
                    && arrayOfEntityIdsToIncludeInSubportfolioFilter.includes(entity.id)

        })
        : null;

    const entityDataSetToUse = onlyShowEntitiesIncludedInSubportfolio ? entitiesInSubportfolios : entities;

    const totalNumEntities = entityDataSetToUse ? Object.keys(entityDataSetToUse).length : null;

    let artificialAverageEntity = null;

    if(showAnalyticsWidget){
        console.log("about to call bbCreateArtificialEntityForPortfolioGroupsUsing the portfollio group", "primarySubportfolioInView", primarySubportfolioInView);
        artificialAverageEntity = bbCreateArtificialEntityForPortfolioGroupsUsing(entityDataSetToUse);
    }
    // console.log("Looking at entityDataSetToUse to see what can be calculated", "entityDataSetToUse", entityDataSetToUse);

    // if(portfolios && customerIdToUse && portfolios[customerIdToUse]) {
    //     console.log("This portfolio contents:", portfolios[customerIdToUse])
    // }

    const currentShares =
        portfolios
        && customerIdToUse
        && portfolios[customerIdToUse]
            ? portfolios[customerIdToUse].shares
            : null;

    // console.log("loadingPortfolios",loadingPortfolios[customerIdToUse], "loadingDeleteBRPortoflkioEntity", loadingDeleteBRPortfolioEntity[customerIdToUse], "loadingAddBRPortfolioEntity", loadingAddBRPortfolioReportRequest[customerIdToUse])

    // useEffect(()=>{
    //     // if(!loadingPortfolios[customerIdToUse]){
    //         dispatch(fetchRiskPortfolio({
    //             customerId: customerIdToUse
    //         }));
    //     // }
    // },[ loadingDeleteBRPortfolioEntity, loadingAddBRPortfolioEntity])

    /**************************/
    /*End Setup State and Dispatch*/
    /**************************/

    const title = <div id={""}>
        {tableTitleIcon} {tableTitleText} {tableTipText && <Tooltip title={tableTipText}>
        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
    </Tooltip>}
    </div>;

    // const handleClickDelete = (data) => {
    //     // console.log("dispatching handleClickDelete with data of", data, customerIdToUse)
    //     dispatch(deleteBRPortfolioEntity({
    //
    //         entityId: data.entityId,
    //         customerId: customerIdToUse,
    //     }));
    // }

    const userTableHeadings = [
        // { field: 'idShort', headerName: 'ID', hide: false, width: 75, sortable: true, type: 'string', renderCell: (params) => {
        //
        //         return <Tooltip title={`${params.row.id}`}>
        //                     <span>
        //                         {params.value}
        //                     </span>
        //         </Tooltip>}},

        { field: 'name', headerName: 'Company Name', hide: false, sortable: true, type: 'string', flex : 1.2, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                        <span>
                              {params.row.logoURL ?
                                  <img style={{height: 20, maxWidth:70}} className={"rounded bg-white p-0 m-1 mr-2 d-inline"} src={params.row.logoURL } />
                                  : <Tooltip title={`Logo for ${params.row.name} could not be found.`}><span className={"d-inline"}><BBIconEmptyBox className={"rounded bg-white p-0 m-1 mr-2 d-inline"} style={{fontSize: "20px"}}/></span></Tooltip>
                              }
                              <Link smooth to={`Details/Scores?entityID=${params.row.id}`} style={{ textDecoration: "none", color: "black" }}>
                                {params.value}
                              </Link>
                            <UpdateEntityNameDialog customerId={params.row.customerId} entityId={params.row.id}>
                        </UpdateEntityNameDialog>
                              <BRCompanyScoreVerifiedBadge entityId={params.row.id} inline hideDescription fontSizeOverride={"14px"}/>
                          </span>

                    </Tooltip>

                ))},
        // { field: 'verifiedBadge', headerName: 'Verified', hide: false, sortable: true, type: 'string', width: 120, renderCell: (params) =>
        //         renderCellExpand(params, (<>{params.value}</>
        //
        //         ))},
        { field: 'addedOn', headerName: 'Date Added', hide: !showManagementOptions || showAnalyticsView, sortable: true, type: 'string', width : 120, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`Date this entity was added to this portfolio.`}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                    </Tooltip>

                ))},
        { field: 'addedBy', headerName: 'Added By', hide: !showManagementOptions || showAnalyticsView || showSlimView, sortable: true, type: 'string', width : 150, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`The user that added this entity to this portfolio.`}>
                          <span>
                                {params.value}
                          </span>
                    </Tooltip>

                ))},
        { field: 'website', headerName: 'Official Website', hide: true, sortable: true, type: 'string', flex : 0.9, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                        <BBExternalLink tipText={`Visit the website of ${params.row.name} in a new browser tab.`} href={`http://${params.value}`}>
                            <code>
                                {params.value}
                            </code>
                        </BBExternalLink>
                    </Tooltip>

                ))},
        { field: 'country', headerName: 'Country', hide: true, sortable: true, type: 'string', flex : 0.5, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                      <span>
                          {params.value}
                      </span>
                    </Tooltip>

                ))},
        { field: 'city', headerName: 'City', hide: true, sortable: true, type: 'string', flex : 0.5, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                      <span>
                          {params.value}
                      </span>
                    </Tooltip>

                ))},
        { field: 'lastScore', headerName: 'BreachRisk™ Score', hide: false, sortable: true, type: 'string', width: 150,
            renderHeader: (params) => <Tooltip
                title={"Lower scores are better, scores range from 0 to 10."}
                heading={"BreachRisk™ Score"}
                link={"https://support.breachbits.com/knowledge/whats-a-breachrisk-score"}
            >
                <BBIconBreachRiskScore/>
            </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      <strong>{parseFloat(params.value).toFixed(1)}</strong> &nbsp;
                                      <Tooltip heading={"Risk Categories"}
                                               width={"400px"}
                                               examples={[
                                                   {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-lowest"}>Very Low Risk</Badge></p>,
                                                       text: null,},
                                                   {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-low"}>Low Risk</Badge></p>,
                                                       text: null,},
                                                   {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-medium"}>Medium Risk</Badge></p>,
                                                       text: null,},
                                                   {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-high"}>High Risk</Badge></p>,
                                                       text: null,},
                                                   {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-highest"}>Very High Risk</Badge></p>,
                                                       text: null,},
                                               ]}
                                               // title={`This BreachRisk™ Score is categorized as: ${bbTranslateBreachRiskScoreToCategory(params.value)} Risk.`}>
                                          >
                                          <span>
                                              <small>
                                              <Badge color={bbTranslateBreachRiskScoreToColor(params.value)}>{bbTranslateBreachRiskScoreToCategory(params.value)} Risk</Badge>
                                              </small>
                                          </span>
                                      </Tooltip>
                                  </span>
                                  : "Pending"}

                          </span>
                    </Tooltip>

                ))},
        // { field: 'lastConfidenceLow', headerName: 'Possible Low', hide: !showInsightsDetails, sortable: true, type: 'string', width: 150, renderCell: (params) =>
        //         renderCellExpand(params, (<Tooltip title={``}>
        //                   <span>
        //                       {params.value
        //                           ? <span>
        //                               {parseFloat(params.value).toFixed(1)} &nbsp;
        //                               <Tooltip title={`This BreachRisk™ Score is categorized as: ${bbTranslateBreachRiskScoreToCategory(params.value)} Risk.`}><span><small><Badge color={bbTranslateBreachRiskScoreToColor(params.value)}>{bbTranslateBreachRiskScoreToCategory(params.value)} Risk</Badge></small></span></Tooltip>
        //
        //                           </span>
        //                           : "N/A"}
        //
        //                   </span>
        //             </Tooltip>
        //
        //         ))},
        // { field: 'lastConfidenceHigh', headerName: 'Possible High', hide: !showInsightsDetails, sortable: true, type: 'string', width: 150, renderCell: (params) =>
        //         renderCellExpand(params, (<Tooltip title={``}>
        //                   <span>
        //                       {params.value
        //                           ? <span>
        //                               {parseFloat(params.value).toFixed(1)} &nbsp;
        //                               <Tooltip title={`This BreachRisk™ Score is categorized as: ${bbTranslateBreachRiskScoreToCategory(params.value)} Risk.`}><span><small><Badge color={bbTranslateBreachRiskScoreToColor(params.value)}>{bbTranslateBreachRiskScoreToCategory(params.value)} Risk</Badge></small></span></Tooltip>
        //
        //                           </span>
        //                           : "N/A"}
        //
        //                   </span>
        //             </Tooltip>
        //
        //         ))},

        { field: 'confidenceCategory', headerName: 'Fidelity', hide: !showInsightsDetails, sortable: true, type: 'string', width: 130,
             sortComparator: (v1, v2, param1, param2) => {
                 let param1Value;
                 let param2Value;
                 switch(param1.value) {
                     case "Very Low Fidelity":
                          param1Value = 0;
                          break;
                     case "Low Fidelity":
                         param1Value = 1;
                         break;
                     case "Medium Fidelity":
                         param1Value = 2;
                         break;
                     case "High Fidelity":
                         param1Value = 3;
                         break;
                     case "Very High Fidelity":
                         param1Value = 4;
                         break;
                     default:
                         param1Value =  null;
                         break;
                 }
                 switch(param2.value){
                     case "Very Low Fidelity":
                         param2Value = 0;
                         break;
                     case "Low Fidelity":
                         param2Value = 1;
                         break;
                     case "Medium Fidelity":
                         param2Value = 2;
                         break;
                     case "High Fidelity":
                         param2Value = 3;
                         break;
                     case "Very High Fidelity":
                         param2Value = 4;
                         break;
                     default:
                         param2Value = null;
                 }
                 return param1Value - param2Value;
            } ,

            renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                            <span>
                                <small>
                                    <BRFidelityBadge cycleObject={params.row.lastCycle}/>
                                </small>
                            </span>
                </Tooltip>

                ))},
        { field: 'lastDateTime', headerName: 'Last Scoring', hide: true, sortable: true, type: 'string', flex : 0.5, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                    </Tooltip>

                ))},
        { field: 'nextDateTime', headerName: 'Next Scoring', hide: !showInsightsDetails || showSlimView, sortable: true, type: 'string', flex : 0.6,
        renderHeader: (params =>
            <span>Next Score</span>)
            ,renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                    </Tooltip>

                ))},

        { field: 'isSubscriptionActive', headerName: 'Active Subscription',
            // renderHeader: (params) => <Tooltip title={"Active Subscription"}>
            //     <span><BBIconVerified/> </span>
            // </Tooltip>,
            //  hide: !showCustomerProcessSteps || showSlimView, sortable: true, type: 'string', width: 60, renderCell: (params) => params.row.verifiedBadge
            renderHeader: (params) => <Tooltip
                heading={"Active Subscription"}
                title={"Active Subscription describes a company's relationship to BreachRisk. " +
                    "Whether or not they have an active account and whether or not that account has been fully verified."}>
                <span><BBIconCompanyVerifiedCheck/></span>
            </Tooltip>, hide: !showCustomerProcessSteps || showSlimView, sortable: true, type: 'string', width: 60,
            renderCell: (params) => params.row.verifiedBadge ? params.row.verifiedBadge : <Tooltip title={''}><BBIconRoundedDashNull/></Tooltip>
            // renderCellExpand(params, (<>
                //
                //         {/*{params.value*/}
                //         {/*    ? <Tooltip title={`Subscription active. This company has an active BreachRisk™ account with access to BreachRisk™ Score and BreachRisk™ Report.`}>*/}
                //         {/*          <span>*/}
                //         {/*            <BBIconCheckCircleYes className={'text-bb-risk-low'}/>*/}
                //         {/*          </span>*/}
                //         {/*    </Tooltip>*/}
                //         {/*    : <Tooltip title={`No active subscription. This company may not be accessing BreachRisk™ Score and BreachRisk™ Report.`}>*/}
                //         {/*          <span>*/}
                //         {/*            <BBIconRoundedDashNull/>*/}
                //         {/*          </span>*/}
                //         {/*    </Tooltip>*/}
                //         {/*}*/}
                //     </>
                //
                // ))
        },
        { field: 'isBRLevel2', headerName: "BreachRisk™ Report Access",
            // renderHeader: (params) => <Tooltip heading={"BreachRisk™ Report Access"}
            //                                    link={'https://support.breachbits.com/knowledge/invite-a-portfolio-entity-to-create-a-breachrisk-account'}
            //                                    title={'Companies can give you enhanced permissions, allowing you to see their BreachRisk™ Report.'}>
            renderHeader: (params) => <Tooltip heading={bbDictionaryOfBreachRiskLevels && bbDictionaryOfBreachRiskLevels[2] && bbDictionaryOfBreachRiskLevels[2].longName}
                                               link={'https://support.breachbits.com/knowledge/invite-a-portfolio-entity-to-create-a-breachrisk-account'}
                                               title={bbDictionaryOfBreachRiskLevels && bbDictionaryOfBreachRiskLevels[2] && bbDictionaryOfBreachRiskLevels[2].description}>
                <span><BBIconGraphChart/></span>
            </Tooltip>,

            hide: !showCustomerProcessSteps || showSlimView, sortable: true, type: 'string', width: 60,
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`You have access to this company's BreachRisk™ Report`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : params.row.hasPendingShare && params.row.shareAccessLevel === 2
                                ? <Tooltip title={`You have sent this company a request but it is pending.`}>
                                      <span>
                                          <BBIconWaitingHourglass className={"text-purple"}/>
                                      </span>
                                </Tooltip>
                                : params.row.isBRLevel1
                                    ? <Tooltip title={`You have access to BreachRisk™ Score, but not to BreachRisk™ Report. Send a sharing request to gain access.`}>
                                          <span>
                                              <BBIconRoundedDashNull/>
                                          </span>
                                    </Tooltip>
                                    : <Tooltip title={`Pending. Please check back soon.`}>
                                          <span>
                                              {/*<BBIconExclamationTriangleError className={'text-bb-risk-highest'}/>*/}
                                              <BBIconRoundedDashNull/>
                                          </span>
                                    </Tooltip>
                        }
                    </>

                ))},
        { field: 'isBRLevel3', headerName: "BreachRisk™ Technical Access",
            renderHeader: (params) => <Tooltip heading={bbDictionaryOfBreachRiskLevels && bbDictionaryOfBreachRiskLevels[3] && bbDictionaryOfBreachRiskLevels[3].longName}
                                               link={'https://support.breachbits.com/knowledge/requesting-access'}
                                               title={bbDictionaryOfBreachRiskLevels && bbDictionaryOfBreachRiskLevels[3] && bbDictionaryOfBreachRiskLevels[3].description}>
                <span><BBIconTechData/></span>
            </Tooltip>,

            hide: (!showCustomerProcessSteps || showSlimView) || !bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3"),
             sortable: true, type: 'string', width: 60,
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`You have access to this company's BreachRisk™ Technical Details`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : params.row.hasPendingShare && params.row.shareAccessLevel === 3
                                ? <Tooltip title={`You have sent this company a request but it is pending.`}>
                                      <span>
                                          <BBIconWaitingHourglass className={"text-purple"}/>
                                      </span>
                                </Tooltip>
                                : params.row.isBRLevel2
                                    ? <Tooltip title={`You have Access to this company's BreachRisk™ Report, but not their Technical Details`}>
                                          <span>
                                              <BBIconRoundedDashNull/>
                                          </span>
                                    </Tooltip>
                                    : <Tooltip title={`Pending. Please check back soon.`}>
                                          <span>
                                              {/*<BBIconExclamationTriangleError className={'text-bb-risk-highest'}/>*/}
                                              <BBIconRoundedDashNull/>
                                          </span>
                                    </Tooltip>
                        }
                    </>

                ))
            // renderCell: (params) =>
            //     renderCellExpand(params, (<>
            //             {params.value
            //                 ? <Tooltip title={`You have access to this company's BreachRisk™ Technical`}>
            //                       <span>
            //                         <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
            //                       </span>
            //                 </Tooltip>
            //                 : <Tooltip title={`You have access to BreachRisk™ Score, but not to BreachRisk™ Report. Contact support if you believe this is an error.`}>
            //                               <span>
            //                                   <BBIconRoundedDashNull/>
            //                               </span>
            //                         </Tooltip>
            //             }
            //         </>
            //
            //     ))
        },
        { field: 'isBRLevel4', headerName: "BreachRisk™ Administrator",
            renderHeader: (params) => <Tooltip link={'https://support.breachbits.com/knowledge/requesting-access'}
                                               heading={bbDictionaryOfBreachRiskLevels && bbDictionaryOfBreachRiskLevels[4] && bbDictionaryOfBreachRiskLevels[4].longName}
                                               title={bbDictionaryOfBreachRiskLevels && bbDictionaryOfBreachRiskLevels[4] && bbDictionaryOfBreachRiskLevels[4].description}>
                <span><BBIconAccountTrustedAgent/></span>
            </Tooltip>,

            hide: (!showCustomerProcessSteps || showSlimView) || !bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3"),
             sortable: true, type: 'string', width: 60,
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`You have full access to this company's BreachRisk™ Details and permission to add and modify information.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : params.row.hasPendingShare && params.row.shareAccessLevel === 4
                                ? <Tooltip title={`You have sent this company a request but it is pending.`}>
                                      <span>
                                          <BBIconWaitingHourglass className={"text-purple"}/>
                                      </span>
                                </Tooltip>
                                : params.row.isBRLevel3
                                    ? <Tooltip title={`You have access to BreachRisk™ Technical Details, but do not have Administrative authority.`}>
                                          <span>
                                              <BBIconRoundedDashNull/>
                                          </span>
                                    </Tooltip>
                                    : <Tooltip title={`Pending. Please check back soon.`}>
                                          <span>
                                              {/*<BBIconExclamationTriangleError className={'text-bb-risk-highest'}/>*/}
                                              <BBIconRoundedDashNull/>
                                          </span>
                                    </Tooltip>
                        }
                    </>

                ))
            // renderCell: (params) =>
            //     renderCellExpand(params, (<>
            //             {params.value
            //                 ? <Tooltip title={`You have administrative privileges for this account.`}>
            //                       <span>
            //                         <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
            //                       </span>
            //                 </Tooltip>
            //                 : <Tooltip title={`You do not have administrative privileges for this account. Contact support if you believe this is an error.`}>
            //                               <span>
            //                                   <BBIconRoundedDashNull/>
            //                               </span>
            //                 </Tooltip>
            //             }
            //         </>
            //
            //     ))
        },
        { field: 'isSubscriptionPro', headerName: 'Pro Subscription',
            renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip
                heading={"Pro Subscription"}
                title={"Whether or not this company has a Pro Level Business Subscription, meaning they have access to penetration testing and other advanced services and reporting."}>
                <span><BBBreachRiskSubscriptionBadge subscriptionLevel={"Pro"} hideTooltip/></span>
            </Tooltip></div>, hide: true, sortable: true, type: 'string', width: 61, renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Pro subscription active. This company has access to Penetration Testing and advanced sharing tools.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`No active Pro subscription. This company has does not have access to Penetration Testing or advanced sharing tools.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'isActiveTestingAuthorized', headerName: 'Penetration Testing',
            renderHeader: (params) => <Tooltip heading={"Penetration Testing"}
                title={"Allows us to obtain more accurate predictions by actively testing the company's defenses. Having penetration testing enabled means your information is more accurate. Only they may authorize this type of testing."}>
                <span><BBIconLevelUpArrowEscalation/></span>
            </Tooltip>, hide: !showCustomerProcessSteps || showSlimView, sortable: true, type: 'string', width: 60, renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`This company has Penetration Testing enabled. Your information about this company is more accurate.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`This company does not have Penetration Testing enabled. Your information about this company is not as accurate as it could be.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'totalProvided', headerName: 'Verifications',
            renderHeader: (params) => <Tooltip title={'Verifications | Companies in your portfolio have the option to tell us where their IT assets are. This increases fidelity and gives you more confidence that we are checking the right areas. The more assets they provide, the better your insights will be.'}>
                <span><BBIconAddNetwork/></span>
            </Tooltip>,

            hide: true, sortable: true, type: 'string', width: 65, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`${params.value > 0 ? `This company has provided ${params.row.providedIPs} IP addresses and ${params.row.providedSubdomains} subdomains. Your insights on this company are more accurate.` : `This company
                 has not provided any additional IT assets. ${params.row.numTrueValidations > 0 ? `But they have provided ${params.row.numTrueValidations} attestation(s), which may mean that we have discovered all of their assets. The overwhelming majority of companies have at least 1 validation.` : `There may be assets related to this company that we are not aware of and therefore your insights are less accurate.`}.`} `}>
                        {/*<Tooltip title={`Organizations in your portfolio have the option to tell us where their IT assets are. This increases fidelity and gives you more confidence that we are checking the right areas. The more assets they provide, the better your insights will be.`}>*/}
                        <span>
                              <Chip
                                  label={`${params.value !== null ? params.value : "N/A"}`}
                                  size={"small"}
                                  // avatar={names.avatar}
                                  color={params.value > 0 ? "primary" : "default"}
                                  // className={params.row.statusId === 1 || params.row.wasRowJustAdded ? "btn-floating pulse pulse-single" : ""}
                                  // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                              />

                          </span>
                    </Tooltip>

                ))},
        { field: 'numTrueValidations', headerName: 'Attestations',
            renderHeader: (params) => <Tooltip extra={true}
                                               heading={"Attestations"}
                                               title={"BreachRisk™ for Business Customers can attest that we have found or been provided all of their IT assets. Recent attestation increase fidelity and mean your insights are better."}
                                                link={'/board/userguide#attestToFindings'}>
                <span><BBIconAttestation/></span>
            </Tooltip>,
            hide: !showCustomerProcessSteps || showSlimView, sortable: true, type: 'string', width: 60, renderCell: (params) => {

                // const now = Date.now();

                return renderCellExpand(params, (<>
                        {params.value > 0
                            ? bbNumDaysBetweenDates(params.row.lastTrueValidationDate) <= 90
                                ? <Tooltip title={`This company has made ${params.value} attestation(s), and at least 1 has been within the last 90 days. The last attestation was made ${bbFormattedDateString(params.row.lastTrueValidationDate, "short")}. Your insights are more accurate for this company.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                                </Tooltip>
                                : <Tooltip title={`This company has made ${params.value} attestation(s), but none within the last 90 days. The last attestation was made ${bbFormattedDateString(params.row.lastTrueValidationDate, "short")}. Your insights would be more accurate for this company if they provide a recent attestation.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-medium'}/>
                                  </span>
                                </Tooltip>

                            : <Tooltip title={`This company has made ${params.value} attestations. Encourage them to make attestations to increase fidelity. Use caution when basing decisions on risk results that have outdated or missing attestations.`}>
                          <span>
                          <BBIconRoundedDashNull/>
                          </span>
                            </Tooltip>
                        }
                    </>

                ))
            }
        },

        { field: 'lastTrueValidationDate', headerName: 'Last Attestation',
            renderHeader: (params) => <Tooltip title={'The last time this company attested that BreachBits has detected all relevant IT infrastructure.'}>
                <span>Last Attestation</span>
            </Tooltip>,
            hide: true, sortable: true, type: 'string', width: 130, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`${bbFormattedDateString(params.value, "long")}`}>
                          <span>
                              {params.value
                                  ? bbFormattedDateString(params.value, "short")
                                  : "N/A"
                              }

                          </span>
                    </Tooltip>

                ))},
        //TODO: uncomment this to add the POV scope badge
        // { field: 'scopeBadge', headerName: 'POV',
        //     renderHeader: (params) => <Tooltip title={'Point of View'}>
        //         <span>POV</span>
        //     </Tooltip>,
        //     hide: !((showCustomerProcessSteps || showInsightsDetails) && !showSlimView), sortable: true, type: 'string', width: 55, renderCell: (params) => params.value
        //         // renderCellExpand(params, (<>{}</>
        //         //
        //         // ))
        // },




        { field: 'numOfTargets', headerName: 'Size of Entity',
            renderHeader: (params) => <Tooltip title={`Relative size. Larger numbers indicate a larger IT infrastructure.`}>
                <span>Size</span>
            </Tooltip>,

            hide: !showInsightsDetails || showSlimView, sortable: true, type: 'string', width: 75, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`Number includes all elements of IT infrastructure that have been discovered or provided.`}>
                {/*// ${params.value > 0 */}
                {/*//         ? `This company has provided ${params.row.providedIPs} IP addresses and ${params.row.providedSubdomains} subdomains. Your insights on this company are more accurate.` */}
                {/*//         : `This organization has not provided any additional IT assets. */}
                {/*// ${params.row.numTrueValidations > 0 */}
                {/*//             ? `But they have provided ${params.row.numTrueValidations} validation(s), which may mean that we have discovered all of their assets.` */}
                {/*//             : `There may be assets related to this organization that we are not aware of and therefore your insights are less accurate.`}.`} `}>*/}
                        {/*<Tooltip title={`Organizations in your portfolio have the option to tell us where their IT assets are. This increases fidelity and gives you more confidence that we are checking the right areas. The more assets they provide, the better your insights will be.`}>*/}
                        <span>
                              <Chip
                                  label={`${params.value ? params.value : "N/A"}`}
                                  size={"small"}
                                  // avatar={names.avatar}
                                  color={"default"}
                                  // className={params.row.statusId === 1 || params.row.wasRowJustAdded ? "btn-floating pulse pulse-single" : ""}
                                  // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                              />

                          </span>
                    </Tooltip>

                ))},

        { field: 'actions', headerName: 'Actions',
            renderHeader: (params) => <></>, disableExport: true,
            hide: !showManagementOptions || showSlimView, width : onlyShowEntitiesIncludedInSubportfolio || !hasEarlyAccess ? 150 : 220, sortable: false, type: 'string',
            renderCell: (params) => {

                return <>
                    <div style={{marginRight:2}} id={"tourActionsSharingRequest"} className={"tourActionsSharingElement"}>
                        {/*<Tooltip title={""}>*/}
                        {/*    <span>*/}
                        {/*<Tooltip title={`${(params.row.hasApprovedShare) */}
                        {/*    ? "You already have an approved sharing relationship with this entity." */}
                        {/*    : params.row.hasPendingShare */}
                        {/*        ? "A sharing request has been sent but not yet accepted. You may send more requests." */}
                        {/*        : "Invite this company to share their BreachRisk™ Report with you and give them access to tools to help them improve their BreachRisk™ Score."}`}>*/}
                            <span>
                            {   loadingAddBRPortfolioReportRequest[params.row.customerId] === true
                                ? <CircularProgress size={16}/>
                                :<BRPortfolioAddReportRequestDialog
                                targetCustomerId={customerIdToUse}
                                targetEntityId={params.row.id}
                                isRequestPending = {params.row.hasPendingShare}
                                isRequestApproved= {params.row.hasApprovedShare} //{params.row.isSubscriptionActive || params.row.isShareExistButPendingApproval}
                            />}
                            </span>
                        {/*</Tooltip>*/}
                        {/*    </span>*/}

                        {/*</Tooltip>*/}
                    </div>
                    {primarySubportfolioInView
                        ? <div style={{marginRight:2}} id={"tourActionSubportfolio"} className={"tourActionSubportfolioElement"}>
                            <span>
                            <BRPortfolioRemoveEntityFromSubportfolioDialog
                                targetCustomerId={customerIdToUse}
                                targetEntity={params.row.entityObject}
                                targetSubportfolio={primarySubportfolioInView}
                                // isRequestPending = {params.row.isShareExistButPendingApproval}
                                // isDisabled= {params.row.isShareApproved} //{params.row.isSubscriptionActive || params.row.isShareExistButPendingApproval}
                            />
                            </span>
                        </div>

                        : hasEarlyAccess &&
                            <div style={{marginRight:2}} id={"tourActionSubportfolio"} className={"tourActionSubportfolioElement"}>
                                <span>
                                <BRPortfolioAddEntityToSubportfolioDialog
                                    targetCustomerId={customerIdToUse}
                                    targetEntity={params.row.entityObject}
                                    // isRequestPending = {params.row.isShareExistButPendingApproval}
                                    // isDisabled= {params.row.isShareApproved} //{params.row.isSubscriptionActive || params.row.isShareExistButPendingApproval}
                                />
                                </span>
                            </div>


                    }

                    {!onlyShowEntitiesIncludedInSubportfolio &&

                        <div style={{marginRight:2}} id={"tourActionArchive"} className={"tourActionArchiveElement"}>
                            <span>
                                <BRPortfolioArchiveEntityDialog
                                    targetEntity={params.row.entityObject}
                                />
                            </span>
                        </div>
                        // <div style={{marginRight:2}}>
                        //     <Tooltip title={"Archive & remove this company from your portfolio. They won't count towards your limit and you can easily add them back later."}>
                        //   <span>
                        //       { loadingDeleteBRPortfolioEntity[params.row.customerId] === true
                        //           ? <div className="loader-view"
                        //                  style={{height: 'calc(100vh - 200px)'}}>
                        //               <CircularProgress/>
                        //           </div>
                        //           // <div className={"text-center align-self-center m-2 p-2"}><CircularProgress size={16}/></div>
                        //           : <Button
                        //               variant="outlined"
                        //               // size={"small"}
                        //               color="default"
                        //               // className={}
                        //               // onClick={}
                        //               // disabled={}
                        //               // className={!isTimelineButtonDisabled ? "text-electric-blue" : ""}
                        //               onClick={() => handleClickDelete({entityId: params.row.id})}
                        //               // disabled={isTimelineButtonDisabled}
                        //           >
                        //               <BBIconArchive />
                        //           </Button>}
                        //   </span>
                        //
                        //     </Tooltip>
                        // </div>
                    }


                </>
            }

        },




    ];

    //peel the state data into a form the dataTable can read
    const tableData = entityDataSetToUse ? mapObject(entityDataSetToUse, (key, entity) => {

        // const applicableShares = filterObject(currentShares, (_, share) => share.entity.id === key);
        //only one share, changing from filtering out several times
        const shareForEntity = currentShares
            && Object.values(currentShares)
                .find((x)=> x.entity && x.entity.id && x.entity.id === key);
        const hasActiveShare = shareForEntity && shareForEntity.is_active;
        const hasApprovedShare = hasActiveShare && shareForEntity.approved;
        const hasPendingShare = hasActiveShare && shareForEntity.requested && !shareForEntity.approved;
        const shareAccessLevel = hasActiveShare && shareForEntity.data_level ?
            shareForEntity.data_level.id
            : null;
        // console.log("applicableShares for ", entity.name, applicableShares, "entity is", entity);

        // console.log("isShareExistButPendingApproval for ", entity.name, isShareExistButPendingApproval, "sharesThatExistButPendingApproval",  sharesThatExistButPendingApproval, "sharesThatAreApproved", sharesThatAreApproved)

        const validationsMarkedTrue = entity.validation ? filterObject(entity.validation, (_, validation) => validation.validated) : null;

        //get all dates from validation objects
        const validationDates = []
        for (const validationId in validationsMarkedTrue) {
            validationDates.push(bbDangerousStringToDate(validationsMarkedTrue[validationId].created_datetime));
        }

        //sort
        // validationDates.sort((a, b) => a - b);
        const sortedValidationDates = validationDates && validationDates
            .sort((a,b) => (bbDangerousStringToDate(a) < bbDangerousStringToDate(b) ? 1 : -1));
        // console.log("sortedValidationDates", sortedValidationDates);

        const lastTrueValidationDate = sortedValidationDates.length ? sortedValidationDates[0] : "--";
        const confidenceLow = entity.last_cycle ? entity.last_cycle.confidence_low : null;
        const confidenceHigh = entity.last_cycle ? entity.last_cycle.confidence_high : null;
        const confidenceCategory = entity.last_cycle ? bbGetDisplayNameFromAPIFidelity(entity.last_cycle.fidelity, true) : null;//bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(confidenceLow, confidenceHigh);

        const portfolioEntityHistory = portfolios && customerIdToUse && portfolios[customerIdToUse] &&  portfolios[customerIdToUse].history;
        const dateThisEntityAdded = portfolioEntityHistory && key && portfolioEntityHistory[key] && portfolioEntityHistory[key].added_on;
        const userThatAddedThisEntity = portfolioEntityHistory && key && portfolioEntityHistory[key] && portfolioEntityHistory[key].added_by;


        // console.log("Checking for portfolioEntityHistory in the BRPEntites Table", portfolioEntityHistory);


        // console.log("looking at the entity in the table", entity)

        return (
            {
                customerId: customer.CustomerId,
                id: key,
                idShort: key.slice(0, 6),
                name: entity.name,
                lastCycle: entity.last_cycle,
                lastScore: entity.last_cycle ? entity.last_cycle.score : null,
                lastConfidenceHigh: confidenceHigh,
                lastConfidenceLow:  confidenceLow,
                confidenceCategory: confidenceCategory,
                lastDateTime: entity.settings ? bbDangerousStringToDate(entity.settings.last_cycle_datetime) : null,
                nextDateTime: entity.settings ? bbDangerousStringToDate(entity.settings.next_cycle_datetime) : null,
                isActiveTestingAuthorized: entity.settings ? entity.settings.active_testing_authorized : null,
                numTrueValidations: validationsMarkedTrue ? Object.keys(validationsMarkedTrue).length : null,
                providedSubdomains: entity.subdomains_provided ? Object.keys(entity.subdomains_provided).length : null,
                providedIPs: entity.targets_provided ? Object.keys(entity.targets_provided).length : null,
                totalProvided: entity.targets_provided ? Object.keys(entity.targets_provided).length : null
                + entity.subdomains_provided ? Object.keys(entity.subdomains_provided).length : null,
                domainsInScope: entity.domains ? Object.keys(entity.domains).length : null,
                numOfTargets: entity.last_cycle && entity.last_cycle.targets ? entity.last_cycle.targets : null,
                website: entity.website,
                country: entity.location_country ? entity.location_country : "--",
                city: entity.location_city ? entity.location_city : "--",
                hasActiveShare: hasActiveShare,
                hasApprovedShare: hasApprovedShare,
                hasPendingShare: hasPendingShare,
                shareAccessLevel: shareAccessLevel,
                // isBRLevel1: bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel1", key),
                isBRLevel1: hasApprovedShare && shareAccessLevel
                    ? shareAccessLevel >=1
                    : !isAdminStaff
                        ? bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel1", key)
                        : true,
                isBRLevel2: hasApprovedShare && shareAccessLevel
                    ? shareAccessLevel >= 2
                    : !isAdminStaff
                    ? bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", key)
                    : true,
                isBRLevel3: hasApprovedShare && shareAccessLevel
                    ? shareAccessLevel >= 3
                    : !isAdminStaff
                        ? bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", key)
                        : true,
                isBRLevel4: hasApprovedShare && shareAccessLevel
                    ? shareAccessLevel === 4
                    : !isAdminStaff
                        ? bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", key)
                        : true,
                // isBRLevel2: bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", key),
                // isBRLevel3: bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", key),
                // isBRLevel4: bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", key),
                // isShareExistButPendingApproval: isShareExistButPendingApproval,
                // isShareApprovedLevel2: isShareApprovedLevel2,
                // isShareApprovedLevel3: isShareApprovedLevel3,
                // isShareApprovedLevel4: isShareApprovedLevel4,
                // isPendingApprovalLevel2: isPendingApprovalLevel2,
                // isPendingApprovalLevel3: isPendingApprovalLevel3,
                // isPendingApprovalLevel4: isPendingApprovalLevel4,
                lastTrueValidationDate: lastTrueValidationDate,
                isSubscriptionActive: entity.active_subscription,
                isSubscriptionPro: entity.pro_subscription,
                logoURL: entity.logo_url,
                addedBy: userThatAddedThisEntity,
                addedOn: dateThisEntityAdded,
                entityObject: entity,
                verifiedBadge: <BRCompanyScoreVerifiedBadge entityId={key} fontSizeOverride={"22px"}/>,
                scopeBadge: <BRCompanyScopeProgressBadge entityId={key} fontSizeOverride={"22px"}/>

            }
        )
    }) : null;

    console.log("tabledata for the portfolios table", tableData, "which is derived from", entityDataSetToUse, "and currentShares", currentShares);
    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    const tableHeaderWidgets = <>{ showManagementOptions
        ? <div className={"row pt-1"}>
            {!primarySubportfolioInView &&
            <div className={"col-9 tourNumberCompanies"} id={"tourNumberOfCompaniesInPortfolio"}>

                    <TileBreachRiskPortfolioNumEntitiesSimple displayModeInlineTableHeader/>

            </div>
                }
            {!primarySubportfolioInView &&
                <div className={"col-2"}>
                    <BBDisableChildren
                        isDisabled={true} //this is somehow inversed logic and true means false //TODO: CORRECT THE LOGIC OF THE isDisabled in BBDisableChildren
                        // moduleRequired = {"insider"}
                        isCompact
                        isButtonSized
                        blurLevel={2}
                    >
                        <div className={"col-12 align-self-center "} id={"tourAddCompanyToPort"}>
                            <BRPortfolioAddNewEntityDialog targetEntityId={selfEntityId}/>
                        </div>
                    </BBDisableChildren>
                </div>
            }

            {primarySubportfolioInView && !showSlimView &&
                <div className={"col-2"}>
                    <BBDisableChildren
                        isDisabled={true} //this is somehow inversed logic and true means false //TODO: CORRECT THE LOGIC OF THE isDisabled in BBDisableChildren
                        // moduleRequired = {"insider"}
                        isCompact
                        isButtonSized
                        blurLevel={2}
                    >
                        <div className={"col-12 align-self-center"}>
                            <BRPortfolioAddEntityToSubportfolioDialog
                                addExistingEntityFromSubportfolioVersion
                                targetSubportfolio={primarySubportfolioInView}
                            />
                        </div>
                    </BBDisableChildren>
                </div>
            }

            {/*{!primarySubportfolioInView &&*/}
            {/*    <div className={"col-2"}>*/}
            {/*        <BBDisableChildren*/}
            {/*            isDisabled={true} //this is somehow inversed logic and true means false //TODO: CORRECT THE LOGIC OF THE isDisabled in BBDisableChildren*/}
            {/*            // moduleRequired = {"insider"}*/}
            {/*            isCompact*/}
            {/*            isButtonSized*/}
            {/*            blurLevel={2}*/}
            {/*        >*/}
            {/*            <div className={"col-12 align-self-center"}>*/}
            {/*                <BRPortfolioAddNewSubportfolioDialog targetEntityId={selfEntityId}/>*/}
            {/*            </div>*/}
            {/*        </BBDisableChildren>*/}
            {/*    </div>*/}
            {/*}*/}
        </div>
        : null
}</>

    const tableRenderComponent = <Row >
        {showAnalyticsWidget && !showMicroAnalyticsWidget &&
            <Col xs={"3"}>
                <div className={"p-2 pl-3"}>
                    <div className="row"  id={""}>
                        <div className={"col-12"}>
                            <h3 className={"text-center"}>Risk Benchmarks</h3>


                        </div>
                    </div>
                    <Row>
                        <Col>
                            <RiskComparisonFactBar
                                useThisEntityInstead={artificialAverageEntity}
                                small
                                avgVarName = "breachrisk_average"
                                thisEntityVarName = "score"
                                factName = "Average BreachRisk™ Score"
                                forcedMaxValue = {10}
                                toolTipDescription={`The group's average BreachRisk™ Score - compared to the global average. Lower risk is better.`}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <RiskComparisonFactBar
                                useThisEntityInstead={artificialAverageEntity}
                                small
                                avgVarName = "likelihood_average"
                                thisEntityVarName = "scored_vector_likelihood_score"
                                factName = "Breach Likelihood"
                                forcedMaxValue = {5}
                                toolTipDescription={`The likelihood that attackers can use detected threats to cause a breach against the average company in this portfolio group - compared to the global average. Lower likelihood is better.`}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <RiskComparisonFactBar
                                useThisEntityInstead={artificialAverageEntity}
                                small
                                avgVarName = "impact_average"
                                thisEntityVarName = "scored_vector_impact_score"
                                factName = "Breach Impact"
                                forcedMaxValue = {5}
                                toolTipDescription={`The impact attackers could make using detected threats against the average company in this portfolio - compared to the global average. Lower impact is better.`}


                            />
                        </Col>
                    </Row>
                </div>

            </Col>
        }

        {!showMicroAnalyticsWidget && !showRiskCategoriesPieInsteadOfTable &&
        <Col xs={showAnalyticsWidget ? "5" : "12"}>
            <div className={`${showAnalyticsWidget ? "py-2" : ""}`}>
                {((entityDataSetToUse || totalNumEntities === 0)
                    // && myEntity
                    // && myEntity.settings
                    && customerIdToUse
                    && !loadingPortfoliosError[customerIdToUse]
                    && !loadingPortfolios[customerIdToUse]
                ) ?
                    <BBDataTable
                        id={"tourPortfolioEntitiesTable"}
                        portfolioTrial
                        subscriptionNameOrId={"BRP"}
                        elementDisplayNameForConsoleLogs={"BRPPortfolioEntitiesTable"}
                        // isActiveSubscriptionRequiredToUse = {false}
                        columns={userTableHeadings}
                        rows={tableDataAsArray()}
                        totalRows={totalNumEntities}
                        progressValue={entities > 0 ? Object.keys(entities).length / totalNumEntities * 100 : 100}
                        // bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                        title={hideTitleHeader ? null : title}
                        description={hideTitleHeader ? null : tableDescription}
                        enableExport={!showSlimView}
                        disableColumnFilter={showSlimView}
                        disableColumnMenu={showSlimView}
                        disableDensitySelector={showSlimView}
                        disableColumnSelector={showSlimView}
                        showProgress={!showSlimView}
                        loading={false}
                        // requiresModule={"monitor"}
                        customer={customer}
                        topRightElement= {tableHeaderWidgets}
                        defaultSortModel = {

                            showManagementOptions
                                ?[
                                    {
                                        field: 'name',
                                        sort: 'asc',
                                    },

                                ]
                                : [
                                    {
                                        field: 'lastScore',
                                        sort: 'asc',
                                    },
                                    {
                                        field: 'confidenceCategory',
                                        sort: 'asc',
                                    }
                                    // {
                                    //     field: 'lastConfidenceHigh',
                                    //     sort: 'asc',
                                    // },
                                    // {
                                    //     field: 'lastConfidenceLow',
                                    //     sort: 'desc',
                                    // },

                                ]
                        }
                        rowsPerPageOptions = {showSlimView ? [5] : [10, 25, 50, 100]}
                        defaultPageSize = {showSlimView ? 5 : 25}
                    />
                    :
                    <BBDataTable
                        columns={userTableHeadings}
                        topRightElement= {tableHeaderWidgets}
                        rows={[]}
                        title={hideTitleHeader ? null : title}
                        description={hideTitleHeader ? null : tableDescription}
                        loading = {true}
                        progressValue={0}
                        bufferValue={0}
                        rowsPerPageOptions = {showSlimView ? [5] : [10, 25, 50, 100]}
                        defaultPageSize = {showSlimView ? 5 : 25}
                        portfolioTrial
                        subscriptionNameOrId={"BRP"}
                    />

                }
            </div>
        </Col>
        }
        {!showMicroAnalyticsWidget && showRiskCategoriesPieInsteadOfTable &&
            <Col xs={showAnalyticsWidget ? "4" : "12"}>
                <TileBreachRiskPortfolioInsightsRiskCategories
                    slimView
                    useTheseEntitiesInstead={entityDataSetToUse}
                />
            </Col>
        }
        {showAnalyticsWidget && !showMicroAnalyticsWidget &&
            <Col xs={showRiskCategoriesPieInsteadOfTable ? "5" : "4"}>
                <div className={"py-2 px-0 pr-2"}>
                    <h3 className={"text-center"}>Risk Landscape</h3>
                    <PortfolioEntityRisk2DScatterPlot
                        useTheseEntitiesInstead={entityDataSetToUse}
                        showSlimView
                    />
                </div>

            </Col>
        }
        {showMicroAnalyticsWidget &&
            <>
                <Col xs={"12"}>

                    <Row>
                        <Col>
                            <div className={"px-2"}>
                                <RiskComparisonFactBar
                                    useThisEntityInstead={artificialAverageEntity}
                                    small
                                    avgVarName = "breachrisk_average"
                                    thisEntityVarName = "score"
                                    factName = "Group Average BreachRisk™ Score"
                                    forcedMaxValue = {10}
                                    toolTipDescription={`The group's average BreachRisk™ Score - compared to the global average. Lower risk is better.`}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PortfolioEntityRisk2DScatterPlot
                                useTheseEntitiesInstead={entityDataSetToUse}
                                showSlimView
                                forceHeightOf={showMicroAnalyticsWidget ? 175 : false}
                            />
                        </Col>
                    </Row>
                </Col>
            </>
        }
    </Row>

    const analyticsWidgetComponent= <>
        <Paper className={"p-0 my-2 mx-1"} >
            <Row>
                <Col>
                    <h1 className={"p-1 m-1 text-left"}>{tableTitleIcon} {primarySubportfolioInView && primarySubportfolioInView.name}</h1>
                </Col>
            </Row>
            {tableRenderComponent}
        </Paper>
    </>

    return showAnalyticsWidget
        ? analyticsWidgetComponent
        : tableRenderComponent;



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer